import { NotificationChannel } from '@kainos/shared';
import type { Notification } from '@kainos/validation';
import { DEMO_TENANT_ID, DEMO_USER } from './session.js';
import { daysAgo, hoursAgo } from './time.js';

const audit = (createdAt: string) => ({
  createdAt,
  createdBy: 'system',
  updatedAt: createdAt,
  updatedBy: 'system',
});

/**
 * What the tray shows in the demo.
 *
 * These mirror what `dispatch-notification` actually writes: only exceptions
 * notify, and every one of them points at the screen where it can be acted on.
 */
export const DEMO_NOTIFICATIONS: Notification[] = [
  {
    id: 'ntf_bloqueo_tablero',
    tenantId: DEMO_TENANT_ID,
    userId: DEMO_USER.id,
    channel: NotificationChannel.IN_APP,
    title: 'Actividad bloqueada',
    body: 'Montaje Eléctrico Subestación Sur: falta de sensores de temperatura por parte del proveedor.',
    link: '/activities/act_2',
    ...audit(hoursAgo(2)),
  },
  {
    id: 'ntf_riesgo_planta',
    tenantId: DEMO_TENANT_ID,
    userId: DEMO_USER.id,
    channel: NotificationChannel.IN_APP,
    title: 'KainOS AI detectó un riesgo',
    body: 'Implementación Planta Norte: revisa el riesgo detectado y confírmalo o descártalo.',
    link: '/projects/prj_plantanorte?tab=riesgos',
    ...audit(hoursAgo(9)),
  },
  {
    id: 'ntf_salud_planta',
    tenantId: DEMO_TENANT_ID,
    userId: DEMO_USER.id,
    channel: NotificationChannel.IN_APP,
    title: 'Proyecto requiere atención',
    body: 'Implementación Planta Norte: el estado pasó de NORMAL a ATTENTION.',
    link: '/projects/prj_plantanorte',
    ...audit(daysAgo(2)),
    readAt: daysAgo(1),
  },
];
